import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CreditCard, Loader2, ShieldCheck, Trash2 } from "lucide-react";
import { toast } from "sonner";
import Navbar from "../../components/Navbar";
import { formatApiError } from "../../lib/api";
import { mk, money, photoUrl } from "../../lib/market";
import { EmailGate } from "../../components/market/EmailGate";
import { useMarketMe } from "./MarketHome";

export default function MarketCart() {
  const [me, reloadMe] = useMarketMe();
  const [cart, setCart] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (me) mk.get("/market/cart").then((r) => setCart(r.data)).catch(() => setCart({ items: [] })); }, [me]);
  async function remove(id) {
    try { const { data } = await mk.delete(`/market/cart/items/${id}`); setCart(data); window.dispatchEvent(new Event("lif-cart")); } catch (e) { toast.error(formatApiError(e)); }
  }
  async function checkout() {
    setBusy(true);
    try { const { data } = await mk.post("/market/cart/checkout", { origin_url: window.location.origin }); window.location.href = data.url; }
    catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  }
  const blocked = cart && cart.items.some((i) => !i.available);
  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <Navbar />
      <div className="container-wide px-5 md:px-12 pt-28 pb-20 max-w-4xl">
        <Link to="/market" className="text-sm text-[var(--muted)] flex items-center gap-1 mb-4" data-testid="cart-back"><ArrowLeft className="w-4 h-4" /> Keep shopping</Link>
        <h1 className="font-serif font-light text-4xl sm:text-5xl mb-8">Your cart</h1>
        {me === null && <EmailGate onDone={reloadMe} />}
        {cart && !cart.items.length && <p className="font-serif text-2xl text-[var(--muted)]" data-testid="cart-empty">Your cart is empty. Tap "Add to cart" on any Buy-now listing.</p>}
        {cart && cart.items.length > 0 && (
          <div className="grid md:grid-cols-[1fr_300px] gap-8 items-start">
            <div className="space-y-3" data-testid="cart-items">
              {cart.items.map((i) => (
                <div key={i.listing_id} className={`bg-white border rounded-2xl p-3 flex gap-4 items-center ${i.available ? "border-[var(--line)]" : "border-red-200 opacity-70"}`} data-testid={`cart-item-${i.listing_id}`}>
                  <Link to={`/market/item/${i.listing_id}`} className="w-20 h-24 rounded-xl overflow-hidden bg-[var(--bg-warm)] shrink-0"><img src={photoUrl(i.photo)} alt="" className="w-full h-full object-cover" /></Link>
                  <div className="flex-1 min-w-0">
                    <p className="font-serif text-xl truncate">{i.title}</p>
                    <p className="text-xs text-[var(--muted)]">{i.seller_name}{i.size ? ` · Size ${i.size}` : ""}</p>
                    {!i.available && <p className="text-xs text-red-600 mt-1" data-testid={`cart-item-sold-${i.listing_id}`}>{i.held ? "Someone is checking out with this right now. Try again in a few minutes." : "Just sold. Remove it to check out."}</p>}
                  </div>
                  <p className="font-serif text-xl">{money(i.price)}</p>
                  <button onClick={() => remove(i.listing_id)} className="p-2 text-[var(--muted)] hover:text-red-600" aria-label="Remove" data-testid={`cart-remove-${i.listing_id}`}><Trash2 className="w-4 h-4" /></button>
                </div>
              ))}
            </div>
            <div className="bg-white border border-[var(--line)] rounded-3xl p-6 md:sticky md:top-28" data-testid="cart-summary">
              <div className="flex justify-between text-sm mb-2"><span className="text-[var(--muted)]">Items</span><span data-testid="cart-count">{cart.ready_count}</span></div>
              <div className="flex justify-between font-serif text-2xl mb-5"><span>Total</span><span data-testid="cart-total">{money(cart.subtotal)}</span></div>
              <button onClick={checkout} disabled={busy || blocked || !cart.ready_count} className="btn-gold w-full" data-testid="cart-checkout">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />} Check out</button>
              <p className="text-[11px] text-[var(--muted)] mt-3 flex gap-1.5"><ShieldCheck className="w-3.5 h-3.5 shrink-0 mt-0.5" /> One secure card payment. You get one invoice by email, and each seller gets their own copy. Test card 4242 4242 4242 4242.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
